import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import { buildStepNarration } from './stepNarrationCopy.js'

export const DESIGN_DNA_FIGMA_PUBLISH_WORKED_LABEL = 'Worked for 4m 08s'

export const DESIGN_DNA_FIGMA_FILE_URL =
  'https://www.figma.com/design/Y2mubgYhu7x8BPYRRPmemC/Enterprise-Dashboard-Kit?node-id=55141-14168&p=f&t=vCREhH2q9AHVG0xs-0'

export const DESIGN_DNA_FIGMA_FILE_NAME = 'Enterprise Dashboard Kit'

export const DESIGN_DNA_FIGMA_PUBLISH_THOUGHT_DETAILS = [
  `The user selected **Enterprise Dashboard Kit** as the publish destination — the M3 showcase is ready, so I'll publish variables and component sets into that project.`,
  `Publish steps:

• **Project:** Enterprise Dashboard Kit *(your selection)*
• **Theme:** Material Design 3 — Primary \`#6750A4\`, tonal palettes, light scheme
• **Output:** share link to the published design system`,
  `Connecting to Figma and writing variables + component sets…`,
]

export const DESIGN_DNA_FIGMA_PUBLISH_INTRO_MARKDOWN = `You selected **Enterprise Dashboard Kit** as the destination project. I'm publishing the **Material Design 3** theme from the showcase — tonal palettes, light color scheme, Roboto typography, and MUI component sets.`

export const DESIGN_DNA_FIGMA_PUBLISH_READY_MARKDOWN = `✅ **Your Figma is ready**

[Enterprise Dashboard Kit](${DESIGN_DNA_FIGMA_FILE_URL})`

export const DESIGN_DNA_FIGMA_JOURNEY_TABLE = [
  {
    Phase: '**A — Design DNA**',
    Input: 'Pinterest moodboard + MUI library',
    Output: '13-phase extraction report · token map · MUI overrides',
    Result: '**✅ Complete**',
  },
  {
    Phase: '**B — MUI Showcase**',
    Input: 'Extracted Design DNA + M3 theme',
    Output: 'Single-file HTML showcase · 60+ component variants',
    Result: '**✅ Complete**',
  },
  {
    Phase: '**C — Figma Publish**',
    Input: 'Showcase tokens + component structure',
    Output: 'Variables + component sets in Enterprise Dashboard Kit',
    Result: '**✅ Complete**',
  },
]

export const DESIGN_DNA_FIGMA_TOKENS_TABLE = [
  {
    Collection: '**Primary**',
    'Key Tokens': 'Primary `#6750A4` · On Primary · Primary Container · On Primary Container',
    Count: '13 steps (0–100)',
  },
  {
    Collection: '**Secondary & Tertiary**',
    'Key Tokens': 'Secondary `#625B71` · Tertiary `#7D5260` · container + on-color pairs',
    Count: '26 steps',
  },
  {
    Collection: '**Neutral & Error**',
    'Key Tokens': 'Surface · Outline · Error · Neutral Variant ramps',
    Count: '22 steps',
  },
  {
    Collection: '**Light Scheme**',
    'Key Tokens': 'sys/light roles — primary, surface, outline, inverse, shadow',
    Count: '29 roles',
  },
]

export const DESIGN_DNA_FIGMA_COMPONENTS_TABLE = [
  {
    Category: '**Material Theme (M3)**',
    'Published Sets': 'Tonal palettes · Light scheme · Design tokens · Chat · Ask bar · Agent question',
    Variants: '12 blocks',
  },
  {
    Category: '**Inputs & Actions**',
    'Published Sets': 'TextField · Button · Checkbox · Radio · Select · Slider · Switch · FAB',
    Variants: '18 sets',
  },
  {
    Category: '**Data & Surfaces**',
    'Published Sets': 'Table · Chip · Avatar · Card · Paper · Accordion · AppBar',
    Variants: '22 sets',
  },
  {
    Category: '**Feedback & Navigation**',
    'Published Sets': 'Alert · Dialog · Progress · Tabs · Drawer · Breadcrumbs · Stepper',
    Variants: '22 sets',
  },
]
